import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { JOVE_LOGO_RED_URL } from 'libs/uikit/src/constants';
import { useLocalTranslation } from '../../../../utils/i18nKit';
import { PortalLoginSourceEnum } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LoginHeader = function LoginHeader(props) {
  var brandInfo = props.brandInfo,
      loginSource = props.loginSource;

  var _useLocalTranslation = useLocalTranslation(),
      $t = _useLocalTranslation.$t;

  var _useState = useState([PortalLoginSourceEnum.Broker, PortalLoginSourceEnum.Org].includes(loginSource) ? 'broker' : 'default'),
      displayType = _useState[0],
      setDisplayType = _useState[1];
  /**
   * effects
   */


  useEffect(function () {
    setDisplayType([PortalLoginSourceEnum.Broker, PortalLoginSourceEnum.Org].includes(loginSource) ? 'broker' : 'default');
  }, [loginSource]);
  return /*#__PURE__*/_jsx(Box, {
    component: "header",
    className: "w-full bg-white",
    children: /*#__PURE__*/_jsxs(Box, {
      className: clsx('mx-auto flex w-full max-w-[1280px] flex-row items-center px-4 md:px-8', ['broker'].includes(displayType) ? 'py-1' : 'py-3'),
      children: [displayType === 'default' && /*#__PURE__*/_jsxs(Box, {
        className: "flex flex-row items-center space-x-3",
        children: [/*#__PURE__*/_jsx(Box, {
          component: "img",
          src: JOVE_LOGO_RED_URL,
          alt: "Jove",
          className: "h-7 w-auto object-contain"
        }), ' ']
      }), displayType === 'broker' && /*#__PURE__*/_jsxs(Box, {
        className: "flex flex-row items-end space-x-3",
        children: [brandInfo !== null && brandInfo !== void 0 && brandInfo.logoUrl ? /*#__PURE__*/_jsx(Box, {
          component: "img",
          src: brandInfo.logoUrl,
          alt: brandInfo === null || brandInfo === void 0 ? void 0 : brandInfo.name,
          className: "h-20 w-auto object-contain"
        }) : /*#__PURE__*/_jsx(Typography, {
          className: "text-lg font-black tracking-tight text-gray-900",
          children: brandInfo === null || brandInfo === void 0 ? void 0 : brandInfo.name
        }), /*#__PURE__*/_jsx(Typography, {
          className: "text-sm font-medium text-gray-500",
          children: $t('text:login.powered_by')
        }), /*#__PURE__*/_jsx(Box, {
          component: "img",
          src: JOVE_LOGO_RED_URL,
          alt: "Jove",
          className: "h-5 w-auto object-contain"
        })]
      })]
    })
  });
};

export default LoginHeader;